import { PropsWithChildren } from 'react';

import { InputTypeContextProvider } from '@/contexts/InputTypeContext';
import { PopupContextProvider } from '@/contexts/PopupContext';

export const AppProviders = ({ children }: PropsWithChildren) => (
  <PopupContextProvider>
    <InputTypeContextProvider>{children}</InputTypeContextProvider>
  </PopupContextProvider>
);
